import { t } from 'i18next';
import { useNav, usePremium, useUser } from '@/hooks';
import { UserAvatar } from '@/components/common/UserAvatar/UserAvatar';
import styles from './MenuContent.module.scss';
import { Trans } from 'react-i18next';
import { LEGACY_ROUTES } from '@/constants/app/routes';
import { ReactComponent as IconInsights } from '@/assets/icons/userMenu/insights.svg';
import { ReactComponent as IconRewards } from '@/assets/icons/userMenu/rewards.svg';
import { ReactComponent as IconPremium } from '@/assets/icons/userMenu/premium.svg';
import { ReactComponent as IconSettings } from '@/assets/icons/userMenu/settings.svg';
import { ReactComponent as IconSupport } from '@/assets/icons/userMenu/support.svg';
import { ReactComponent as IconLogout } from '@/assets/icons/misc/logout.svg';
import { EUserAvatarSize } from '@/models';
import { ANALYTICS } from '@/constants/analytics/analytics';

interface IUserMenuItem {
  label: string;
  onClick: () => void;
  icon: React.ReactNode;
}

export const MenuContent: React.FC = () => {
  const { user, logout } = useUser();
  const { navLegacy } = useNav();
  const premiumHook = usePremium();
  const onViewAccountClick = () => {
    navLegacy(LEGACY_ROUTES.ACCOUNT);
  };

  const onInsightsClick = () => {
    navLegacy(LEGACY_ROUTES.INSIGHTS);
  };
  const onRewardsClick = () => {
    navLegacy(LEGACY_ROUTES.REWARDS);
  };
  const onSettingsClick = () => {
    navLegacy(LEGACY_ROUTES.SETTINGS);
  };
  const onSupportClick = () => {
    window.open(LEGACY_ROUTES.SUPPORT, '_blank');
  };
  const onPremiumClick = () => {
    premiumHook.openPremium({
      source: ANALYTICS.VALUES.PROFILE_MENU_PREMIUM_ITEM,
    });
  };

  const userMenuItems: IUserMenuItem[] = [];
  userMenuItems.push({
    label: t('header.userMenu.insights'),
    onClick: onInsightsClick,
    icon: <IconInsights />,
  });
  if (!user.isPremium) {
    userMenuItems.push({
      label: t('header.userMenu.premium'),
      onClick: onPremiumClick,
      icon: <IconPremium />,
    });
  }
  userMenuItems.push({
    label: t('header.userMenu.rewards'),
    onClick: onRewardsClick,
    icon: <IconRewards />,
  });
  userMenuItems.push({
    label: t('header.userMenu.settings'),
    onClick: onSettingsClick,
    icon: <IconSettings />,
  });
  userMenuItems.push({
    label: t('header.userMenu.support'),
    onClick: onSupportClick,
    icon: <IconSupport />,
  });
  return (
    <div className={styles.menuContent}>
      <div className={styles.menuAccount}>
        <UserAvatar size={EUserAvatarSize.medium} />
        <div className={styles.menuAccountInfo} onClick={onViewAccountClick}>
          <div className={styles.menuAccountName}>
            {user.displayName || user.email}
          </div>
          <div className={styles.menuAccountEmail}>
            <Trans i18nKey="header.userMenu.viewAccount" />
          </div>
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.menuItems}>
        {userMenuItems.map((item, index: number) => (
          <div
            className={styles.menuItem}
            onClick={item.onClick}
            key={`menu-item-${index}`}
          >
            {item.icon}
            <div className={styles.menuItemLabel}>{item.label}</div>
          </div>
        ))}
      </div>
      <div className={styles.divider} />
      <div
        className={styles.menuLogout}
        onClick={() => logout(ANALYTICS.SOURCE.ACCOUNT_DROPDOWN)}
      >
        <IconLogout />
        <div className={styles.menuLogoutLabel}>
          <Trans i18nKey="header.userMenu.logout" />
        </div>
      </div>
    </div>
  );
};
